(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class BdHeroSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-slider]'); this.slides = [...this.querySelectorAll('[data-slide]')]; this.index = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.querySelectorAll('[data-dot]').forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
      this.viewport?.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') this.go(this.index - 1); if (event.key === 'ArrowRight') this.go(this.index + 1); });
      if (this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.speed));
    }
    disconnectedCallback() { clearInterval(this.timer); }
    go(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      const slide = this.slides[this.index];
      if (slide && this.viewport) {
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollTo({ left: slide.offsetLeft, behavior });
      }
      this.querySelectorAll('[data-dot]').forEach((dot, i) => i === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
    }
  }
  if (!customElements.get('bd-hero-slider')) customElements.define('bd-hero-slider', BdHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
